var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.667,
    r: 15,
    fill: "#3CD856"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9696 10.616L16.4947 10.9695C16.1166 11.0236 15.8077 11.2038 15.5871 11.4528L9.81256 17.2274C9.22677 17.8132 9.22675 18.7629 9.81256 19.3487L11.9339 21.4701C12.5197 22.0559 13.4694 22.0558 14.0552 21.4701L19.8298 15.6955C20.0788 15.4749 20.2591 15.166 20.3131 14.7879L20.6666 12.313C20.8081 11.3231 19.9595 10.4745 18.9696 10.616ZM17.2372 14.0454C17.5301 14.3383 18.0049 14.3383 18.2978 14.0454C18.5907 13.7525 18.5907 13.2777 18.2978 12.9848C18.005 12.6919 17.5301 12.6919 17.2372 12.9848C16.9443 13.2777 16.9443 13.7526 17.2372 14.0454Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tagIcon.ffc7d0de5426a31e2a0cc4f35e5ba053.svg";
export { ForwardRef as ReactComponent };